const menuHamburger = document.querySelector('.js-hamburger');
const menuToggleEls = document.querySelectorAll('.js-menu-toggle');
const headerMenuContainer = document.querySelector('.js-header-menu-container');
const menu = document.querySelector('.js-menu-open');
const branch = document.querySelector('.js-branch');

if (menuHamburger && menu) {
  menuHamburger.addEventListener('click', () => {
    menu.classList.toggle('js-active');
    menuHamburger.classList.toggle('js-active');
    headerMenuContainer.classList.toggle('js-active');
    branch.classList.toggle('js-menu-active');
    document.body.classList.toggle('js-menu-active');
  });
}

if (menuToggleEls) {
  [...menuToggleEls].forEach((item) => {
    item.addEventListener('click', (event) => {
      event.target.classList.toggle('js-active');
      event.target.parentElement.classList.toggle('js-active');
      event.target.parentElement.nextElementSibling.classList.toggle('js-active');
    });
  });
}
